import { useState } from 'react';
import { saveUserSettingsCookie } from '@Components/Utilities/CookieHelper';
import LanguageSelector from '@Components/Shared/LanguageSelector';
import CountrySelector from '@Components/Shared/CountrySelector';
import CurrencySelector from '@Components/Shared/CurrencySelector';
import UnitSelector from '@Components/Shared/UnitSelector';
import Button from '@mui/material/Button';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import TimeZoneSelector from '@Components/Shared/TimeZoneSelector';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';

const UserSettingSelector = (props) => {

    const {
        useRowView = false,
        submitButtonText = translator.translate('sandhills.confirm')
    } = props;

    const currentUser = useRecoilValue(atoms.currentUser);
    const [selectedZone, setSelectedZone] = useState(currentUser.FullUserTimeZone);
    const [language, setLanguage] = useState(props.LanguageSelector ? props.LanguageSelector.CurrentLanguage.LanguageCode : null);
    const [country, setCountry] = useState(props.CountrySelector ? props.CountrySelector?.CurrentCountry?.CountryCode : null);
    const [currency, setCurrency] = useState(props.DefaultCurrency);
    const [unit, setUnit] = useState(props.DefaultUnit);
    const routes = useRecoilValue(atoms.routes);
    const currentSite = useRecoilValue(atoms.currentWebsite);


    const onSubmit = () => {
        saveUserSettingsCookie({ unit: unit, currency: currency, languageCode: language, timeZone: selectedZone, countryCode: country, url: routes.SaveUserSettings })
            .then(data => {
                // Hide referrer information for frameless sites
                if (currentSite.IsFramelessSite) {
                    const element = document.createElement("a");
                    element.href = data.url;
                    element.rel = LinkRelationTypes.noReferrer;
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                } else {
                    window.location.href = data.url;
                }
            })
            .catch(error => {
                console.log('Error saving UserSettings cookie: ', error);
                window.location.reload(true);
            });
        if (props.setPrefCookie) {
            props.setPrefCookie();
        }
    };

    return (
        <div className={'user-setting-selector'}>
            <div className={'user-setting-selector__dropdowns' + (useRowView ? ' row-view' : '')}>
                {props.LanguageSelector &&
                    <LanguageSelector
                        {...props.LanguageSelector}
                        {...props.languageSettings}
                        value={language}
                        onChange={(value) => setLanguage(value)}
                        popperDisablePortal={props.popperDisablePortal}
                    />}
                {props.CountrySelector &&
                    <CountrySelector
                    {...props.CountrySelector }
                    value={country}
                    onChange={(value) => setCountry(value)}
                    popperDisablePortal={props.popperDisablePortal}
                    langCode={language}
                    />}
                {props.ShowCurrencySelector &&
                    <CurrencySelector
                        {...props}
                        {...props.currencySettings}
                        value={currency}
                        onChange={(value) => setCurrency(value)}
                        useMUI
                    />}
                {props.ShowUnitSelector &&
                    <UnitSelector
                        {...props}
                        {...props.unitSettings}
                        value={unit}
                        onChange={(value) => setUnit(value)}
                    />}
            </div>
            {props.ValidTimeZones &&
                <>
                    <div className={'user-setting-selector__dropdowns' + (useRowView ? ' timezone-view' : '')}>
                        <p>{translator.translate('sandhills.tradepubwebsite.mvc.whereverpossibledisplaythefollowingtimezone')}</p>
                        <TimeZoneSelector
                            {...props}
                            value={selectedZone}
                            onChange={(value) => setSelectedZone(value)}
                        />
                    </div>
                </>
            }
            <Button onClick={onSubmit} color={currentSite.ThemeOverride} className={'user-setting-selector__button template-branded-button' + (useRowView ? ' row-view' : '')}>
                {submitButtonText}
            </Button>
        </div>
    );
};

export default UserSettingSelector;